module.exports = "/static/hooks/build/assets/open-iconic-527eff645d8ead16666afb6931041279.otf";